<div class="container-fluid" appPadding>
  <div class="row">
    <div class="col">
      <form (submit)="onSave()" #f="ngForm">
        <div class="row">
          <div class="col">
            <fieldset>
              <legend><h4>Monitoring</h4></legend>
              <mat-checkbox [(ngModel)]="isSentryActive" matTooltip="When enabled, Sentry will capture and monitor application errors." name="sentry_kill_switch">
                Enable Sentry Monitoring
              </mat-checkbox>
              <mat-hint>When enabled, Sentry will capture and monitor application errors.</mat-hint>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button class="mt-3" mat-raised-button color="primary" [disabled]="!f.valid || inProgress">
              <mat-icon>save</mat-icon>
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
